export const views = {
  researchers: 'researcher',
  organisations: 'organisation',
};
